import "../../style/Button.css";

const Button = ({ children, variant = "default", size = "default", className = "", ...props }) => {
  const classes = `btn btn-${variant} btn-${size} ${className}`;

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export { Button };